<template>
  <div class="ion-padding bg-white h-100">
    <ion-skeleton-text v-if="loading" :animated="true" style="height: 100%"></ion-skeleton-text>
    <div class="profile-edit" v-else>
      <Form
        form-name="login"
        id="loginForm"
        :validation-schema="schemaProfileEdit"
        @submit="handlePersonalizeSubmit"
      >
        <ion-row>
          <ion-col size="11">
            <h4 class="h3 text-color-body text-align-left">{{ t('profile.editTitle') }}</h4>
            <ion-label>{{ t('profile.editDescription') }}</ion-label>
          </ion-col>
          <ion-col size="1" v-if="!hideCloseButton">
            <ion-icon
              :icon="closeOutline"
              size="large"
              @click.prevent="toggleEditProfile = false"
            />
          </ion-col>
        </ion-row>
        <ion-row style="margin-bottom: 100px" class="profile-menu-content">
          <ion-col size="12" class="d-flex ion-align-items-center ion-justify-content-center">
            <UserAvatar :width="128" :height="128" update-photo />
          </ion-col>
          <ion-col size="12" class="mt-16">
            <CustomInput
              form-name="profile"
              type="text"
              :value="profileForm.name"
              v-model="profileForm.name"
              input-type="text"
              :label="t('profile.labels.name')"
              name="name"
              class-name="custom-field"
              :placeholder="t('profile.placeholders.name')"
              :clear-field="false"
              @update:model-value="onUpdateModel()"
            />
          </ion-col>
          <ion-col size="12">
            <CustomInput
              form-name="profile"
              type="text"
              :value="profileForm.lastName"
              v-model="profileForm.lastName"
              input-type="text"
              :label="t('profile.labels.lastName')"
              name="lastName"
              class-name="custom-field"
              :placeholder="t('profile.placeholders.lastName')"
              :clear-field="false"
              @update:model-value="onUpdateModel()"
            />
          </ion-col>
          <ion-col size="12">
            <CustomInput
              form-name="profile"
              type="text"
              :value="profileForm.genre"
              v-model="profileForm.genre"
              input-type="select"
              :label="t('profile.labels.gender')"
              name="genre"
              class-name="custom-field"
              :icon="homeOutline"
              :options="genderOptions"
              item-id="id"
              item-name="label"
              @update:model-value="onUpdateModel()"
            />
          </ion-col>
          <ion-col size="12" class="px-xs py-zero pt-xs">
            <h4 class="text-sm text-weight-bold text-color-placeholder text-align-left">
              {{ t('profile.contactData') }}
            </h4>
          </ion-col>
          <ion-col size="5">
            <CustomInput
              form-name="profile"
              type="text"
              :value="profileForm.prefixPhone"
              v-model="profileForm.prefixPhone"
              input-type="dial-code"
              :label="t('profile.labels.code')"
              name="prefixPhone"
              class-name="custom-field"
              :language="languageSelected"
              :clear-field="false"
              :read-only="true"
              @update:model-value="onUpdateModel()"
            />
          </ion-col>
          <ion-col size="7">
            <CustomInput
              form-name="profile"
              type="text"
              :value="profileForm.phoneNumber"
              v-model="profileForm.phoneNumber"
              input-type="number"
              :label="t('profile.labels.phoneNumber')"
              name="phoneNumber"
              class-name="custom-field"
              @update:model-value="onUpdateModel()"
            />
          </ion-col>
          <ion-col size="12" class="px-xs pt-xs">
            <h4 class="text-sm text-weight-bold text-color-placeholder text-align-left">
              {{ t('profile.moreAboutMe') }}
            </h4>
          </ion-col>
          <ion-col size="12">
            <CustomInput
              form-name="profile"
              type="text"
              :value="profileForm.NationalityId"
              v-model="profileForm.NationalityId"
              input-type="nationality"
              :language="languageSelected"
              :label="t('profile.labels.nationality')"
              name="nationality"
              class-name="custom-field"
              :read-only="true"
              @update:model-value="onUpdateModel()"
            />
          </ion-col>
          <ion-col size="12" class="mt-8">
            <CustomInput
              form-name="profile"
              type="text"
              :value="profileForm.documentType"
              v-model="profileForm.documentType"
              input-type="select"
              :label="t('profile.labels.documentType')"
              name="documentType"
              class-name="custom-field"
              :options="documentOptions"
              item-id="id"
              item-name="label"
              @update:model-value="onUpdateModel()"
            />
          </ion-col>
          <ion-col size="12">
            <CustomInput
              form-name="profile"
              type="text"
              :value="profileForm.documentId"
              v-model="profileForm.documentId"
              input-type="number"
              :label="t('profile.labels.documentId')"
              name="documentId"
              class-name="custom-field"
              @update:model-value="onUpdateModel()"
            />
          </ion-col>

          <ion-col size="12" class="mt-sm">
            <CustomInput
              form-name="personalize"
              type="date"
              :value="profileForm.birthday"
              v-model="profileForm.birthday"
              input-type="date"
              :label="t('personalize.labels.birthdate')"
              name="birthdate"
              :placeholder="t('personalize.placeholders.birthdate')"
              :clear-field="false"
              @update:model-value="onUpdateModel()"
            />
          </ion-col>
          <ion-col size="12" class="mt-sm">
            <CustomInput
              form-name="personalize"
              type="text"
              :value="profileForm.location"
              v-model="profileForm.location"
              input-type="searchMap"
              :label="t('personalize.labels.location')"
              name="location"
              class-name="custom-field"
              :placeholder="t('personalize.placeholders.location')"
              :icon="locationOutline"
              :clear-field="false"
              @getLocation="geLocation"
              @update:model-value="onUpdateModel()"
            />
          </ion-col>
          <ion-col v-if="!hideUploadDocument" size="12" class="px-xs pt-xs">
            <h4 class="text-sm text-weight-bold text-color-placeholder text-align-left">
              {{ t('profile.documentTitle') }}
            </h4>
          </ion-col>
          <ion-col size="12" v-if="!hideUploadDocument" class="py-xs">
            <ion-button fill="outline" class="d-flex text-align-left" @click="toggleDocument = true"
              >{{ t('files.uploadDocument') }}
            </ion-button>
          </ion-col>
        </ion-row>
        <div class="button-wrapper">
          <ion-row>
            <ion-col size="6">
              <ion-button
                v-if="!showContinueButton"
                expand="block"
                color="primary"
                fill="clear"
                class="text-weight-bold"
                @click="discardChanges"
                >{{ t('actions.discard') }}
              </ion-button>
            </ion-col>
            <ion-col size="6" class="pb-lg">
              <ion-button
                :disabled="!isProfileCompleted || disableContinueButton"
                expand="block"
                color="primary"
                fill="solid"
                class="text-weight-bold"
                type="submit"
              >
                <div v-if="!showContinueButton">
                  {{ t('actions.saveChanges') }}
                </div>
                <div v-else>
                  <ion-icon slot="end" :icon="chevronForwardOutline"></ion-icon>
                  {{ t('global.continue') }}
                </div>
              </ion-button>
            </ion-col>
          </ion-row>
        </div>
      </Form>
    </div>
  </div>
</template>
<script setup lang="ts">
  import {
    chevronForwardOutline,
    closeOutline,
    homeOutline,
    locationOutline,
  } from 'ionicons/icons';
  import { IonButton, IonCol, IonIcon, IonLabel, IonRow, IonSkeletonText } from '@ionic/vue';
  import { countries } from '@/utils/constants/country-codes';
  import UserAvatar from '@/components/shared/avatar/UserAvatar.vue';
  import { useProfile } from '@/composables/useProfile';
  import CustomInput from '@/components/shared/form/CustomInput.vue';
  import { useI18n } from 'vue-i18n';
  import { onMounted, ref, watch } from 'vue';
  import { Form } from 'vee-validate';
  import { useMap } from '@/composables/useMap';
  import { useDocuments, useGenders } from '@/utils/constants/general-constants';
  import { ICountry, Nationality } from '@/interfaces/maps/maps.interface';
  import { IPlaceLocation } from '@/interfaces/auth/auth-store.interface';
  import { storeToRefs } from 'pinia';
  import { useProfileStore } from '@/stores/profile-store';
  import { useSchemas } from '@/composables/useSchemas';

  const { t } = useI18n();
  const {
    isProfileCompleted,
    toggleEditProfile,
    toggleDocument,
    profileForm,
    loading,
    handlePutProfile,
    handleGetProfile,
    handleGetDocuments,
    handleGetProfileLocation,
  } = useProfile();
  const { nationalities, handleGetNationalities } = useMap();
  const { languageSelected } = storeToRefs(useProfileStore());
  const { schemaProfileEdit } = useSchemas();

  const genderOptions = useGenders();
  const documentOptions = useDocuments();
  const selectedNationality = ref<Nationality | null>(null);
  const selectedCountry = ref<ICountry | null>(null);
  const isEdited = ref(false);

  const handlePersonalizeSubmit = () => {
    handlePutProfile().then(async () => {
      await handleGetProfile();
      await handleGetProfileLocation();
      discardChanges();
    });
  };

  const geLocation = (location: IPlaceLocation) => {
    profileForm.value.Location = location;
  };

  defineProps({
    hideUploadDocument: {
      type: Boolean,
      default: false,
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
    showContinueButton: {
      type: Boolean,
      default: false,
    },
    disableContinueButton: {
      type: Boolean,
      default: false,
    },
  });

  const initialConfig = async () => {
    loading.value = true;
    handleGetNationalities().then(async () => {
      await handleGetDocuments();
      await handleGetProfile();
      await handleGetProfileLocation();
      verifyIsEditedNationality();
      verifyIsSavedData();

      loading.value = false;
    });
  };

  const verifyIsEditedNationality = () => {
    const nationalitySelected =
      nationalities.value.find((country) => country.id === profileForm.value.NationalityId) || null;

    const countryCode =
      countries.find((country: ICountry) => country.dialCode === profileForm.value.prefixPhone) ||
      null;

    if (
      nationalitySelected &&
      countryCode &&
      nationalitySelected.countryCode !== countryCode.code
    ) {
      isEdited.value = true;
    }
  };

  const discardChanges = () => {
    localStorage.removeItem('profile-saved');
    toggleEditProfile.value = false;
  };
  const onUpdateModel = () => {
    localStorage.setItem('profile-saved', JSON.stringify(profileForm.value));
  };

  const verifyIsSavedData = () => {
    if (localStorage.getItem('profile-saved')) {
      profileForm.value = JSON.parse(localStorage.getItem('profile-saved') as string);
    }
  };

  onMounted(() => {
    initialConfig();
  });

  watch(
    () => profileForm.value.prefixPhone,
    (newVal) => {
      if (!isEdited.value) {
        selectedCountry.value =
          countries.find((country: ICountry) => country.dialCode === newVal) || null;

        if (selectedCountry.value) {
          selectedNationality.value =
            nationalities.value.find(
              (nationality) => nationality.countryCode === selectedCountry.value?.code,
            ) || null;

          profileForm.value.NationalityId = selectedNationality.value?.id || -1;
        } else {
          selectedNationality.value = null;
          profileForm.value.NationalityId = -1;
        }
      }
    },
  );

  watch(
    () => profileForm.value.NationalityId,
    () => {
      verifyIsEditedNationality();
    },
  );
</script>
<style scoped lang="scss">
  .button-wrapper {
    background: white;
    position: fixed;
    bottom: 0;
    width: 92%;
    padding: 10px 0 30px 0;
    z-index: 999;
  }

  .profile-edit {
    --border-radius: 25px;
    --background: white;
  }

  .profile-menu-content {
    max-height: 78vh;
    overflow-y: auto;
  }
</style>
